import { jsx as n } from "react/jsx-runtime";
import { s as v } from "../../../TabSet.module-C8hFDW4m.js";
import { focusableElements as f } from "../../../utils/helpers.dom.js";
import { a as p } from "../../../floating-ui.react-DxYXKqW-.js";
const S = ({
  children: A,
  handleSelection: a,
  index: s,
  selected: o,
  value: u,
  ...m
}) => {
  const d = (r, t, i) => {
    var c;
    const e = r.querySelector("[id]"), b = e == null ? void 0 : e.getAttribute("id");
    e == null || e.removeAttribute("id"), r.removeAttribute("tabindex"), r.removeAttribute("data-active"), r.removeAttribute("aria-selected"), (c = i.ref) == null || c.call(i, t), t.tabIndex = o ? 0 : -1, o ? t.setAttribute("data-active", "") : t.removeAttribute(""), b && t.setAttribute("id", b), t.setAttribute("aria-selected", String(o));
  };
  return /* @__PURE__ */ n(
    p,
    {
      render: (r) => /* @__PURE__ */ n(
        "div",
        {
          ...m,
          ...r,
          "aria-selected": o,
          className: v.listItem,
          onClick: () => a(s, u),
          onKeyDown: (t) => ["Space", "Enter"].includes(t.key) && a(s, u),
          ref: (t) => {
            if (!t)
              return;
            const i = f(t)[0];
            i && d(
              t,
              i,
              r
            );
          },
          children: A
        }
      )
    }
  );
};
export {
  S as TabSetItem
};
